import { render, staticRenderFns } from "./loginCucc.vue?vue&type=template&id=827a7548&scoped=true&"
import script from "./loginCucc.vue?vue&type=script&lang=js&"
export * from "./loginCucc.vue?vue&type=script&lang=js&"
import style0 from "./loginCucc.vue?vue&type=style&index=0&id=827a7548&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827a7548",
  null
  
)

export default component.exports